import React from "react";
import TerminalDetails from "./TerminalDetails";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Accordion from "react-bootstrap/Accordion";
import PopoverMerchantAlias from "./PopoverMerchantAlias";
import PopoverPostCode from "./PopoverPostCode";
import store from "../../store";
import {getMap} from "../../providers/rest";
import {getBusinessExcel} from "../../providers/merchants";
import connect from "react-redux/es/connect/connect";
import Tooltip from "../common/Tooltip";
import {toggleInfoTooltips} from "../../actions/userActions";
import PaymentsAndFees from "./PaymentsAndFees";
import DebitNotes from "./DebitNotes/DebitNotes";

const Translate = require('react-redux-i18n').Translate;
const fileDownload = require('js-file-download')

const stateMap = (store) => {
    return {
        merchantReducer: store.merchantReducer,
        userReducer: store.userReducer
    };
};

class MidDetails extends React.Component {
    constructor(props) {
        super(props)
        this.businessModalRef = React.createRef();
        this.overlayContainerRef = React.createRef();
        this.state = {
            data: props.data,
            acquirersMap: null,
            disableExcel: false,
            merchantAlias: props.data?.merchantAlias ?? null,
            showOverlayMerchantAlias: false,
            showOverlayPostCode: false,
            isEcom: props.isEcom !== undefined ? props.isEcom : false
        }
        this.getAcquirersMap = this.getAcquirersMap.bind(this)
        this.handleAliasChange = this.handleAliasChange.bind(this)
        this.handlePostCodeChange = this.handlePostCodeChange.bind(this)
        this.toggleOverlayMerchantAlias= this.toggleOverlayMerchantAlias.bind(this)
        this.toggleOverlayPostCode= this.toggleOverlayPostCode.bind(this)
        this.getMerchantExcel = this.getMerchantExcel.bind(this)
        this.tidsSearchBoxData = this.tidsSearchBoxData.bind(this);
    }

    componentWillMount() {
        this.getAcquirersMap('acquirers')
    }

    toggleOverlayMerchantAlias() {
        this.setState((prevState) => {
            return {
                showOverlayMerchantAlias: !prevState.showOverlayMerchantAlias
            }
        }, () => {
            if (this.state.showOverlayMerchantAlias && this.props.userReducer.showInfo__business_mid_alias_tltp) {
                store.dispatch(toggleInfoTooltips("showInfo__business_mid_alias_tltp", false))
            }
        })
    }

    toggleOverlayPostCode() {
        this.setState(prevState => ({
            showOverlayPostCode: !prevState.showOverlayPostCode
        }));
    }

    handlePostCodeChange(mid, postCode) {
        const data = this.state.data;
        data.portalPostCode = postCode;
        this.setState({
            data: data
        }, () => {
            this.props.handlePostCodeChange(postCode ? postCode : data.locationPostCode)
        })
    }


    handleAliasChange(mid, merchantAlias) {
        const data = this.state.data;
        data.merchantAlias = merchantAlias;
        this.setState({
            data: data
        }, () => {
            this.props.handleAliasChange(mid, merchantAlias, 'mid')
        })

    }

    getAcquirersMap(mapName) {
        store.dispatch(getMap(mapName)).then((response) => {
                this.setState({
                    acquirersMap: this.props.locale === 'en' ? response.value.data.latin : response.value.data.greek
                })
            }, (error) => {
            }
        )
    }

    tidsSearchBoxData(tidData) {
        return tidData.map((tid)=> {
           return {label: tid.tid + (tid.terminalAlias ? '-' + tid.terminalAlias : ''),
                        value: tid.tid,
                        id: "debit-note-" + tid.tid
            };
        })
    }

    getMerchantExcel(afm, mid, tid, onlyActive) {
        this.setState({
            disableExcel: true
        })
        store.dispatch(getBusinessExcel(-1, afm, mid, tid, onlyActive, this.props.locale)).then((response) => {
            fileDownload(response.value.data, response.value.headers.filename)
            this.setState({
                disableExcel: false
            })
        })
    }

    render() {
        const data = this.state.data ?? null;
        const postCode = data.portalPostCode ?? data.locationPostCode ?? null;
        const isNotSingleAfmMid = this.props.userReducer.getAssociationsResponse.merchantType !== 'singleAfmMid';
        let popoverMerchantAliasProps = {
            afm: this.props.merchantReducer.afm,
            mid: this.state.data.mid,
            merchantAlias: this.state.data.merchantAlias,
            handleAliasChange: this.handleAliasChange,
            toggleMerchantAliasOverlay: this.toggleOverlayMerchantAlias,
            isEcom: this.state.isEcom,
            setAliasesArr: this.props.setAliasesArr,
            updateTerminalAllias: this.props.updateTerminalAllias
        };
        const popoverMerchantAlias = (
            <Popover id={"business-merchantAlias-popover-positioned-bottom"}>
                <Popover.Body>
                    <PopoverMerchantAlias
                        {...popoverMerchantAliasProps}
                    />
                </Popover.Body>
            </Popover>
        );
        const popoverPostCode = (
            <Popover id={"business-postCode-popover-positioned-bottom"}>
                <Popover.Body>
                    <PopoverPostCode
                        mid={this.state.data.mid}
                        postCode={postCode}
                        overlayPostCodeRef={this.refs.overlayPostCodeRef}
                        handlePostCodeChange={this.handlePostCodeChange}
                        togglePostCodeOverlay={this.toggleOverlayPostCode}
                    />
                </Popover.Body>
            </Popover>
        );
        return (
            <div ref={this.overlayContainerRef}>
                <div id="business-modal__content"
                     ref={this.businessModalRef}
                     className={isNotSingleAfmMid ? 'multiple-stats__content':''}
                     key={"business-modal-content-" + data.mid}>
                {isNotSingleAfmMid ?
                    <button className={"__mid-excel-button " + (this.state.disableExcel === true ? "disabled" : "")}
                            onClick={() => this.getMerchantExcel(this.props.merchantReducer.afm, data.mid, null, false)}
                            disabled={this.state.disableExcel === true}>
                    </button> : null}
                <Accordion defaultActiveKey={["0", "2"]} alwaysOpen>
                    <Accordion.Item eventKey="0"
                                    id="accordion-company-details">
                        <Accordion.Header as='h4'>
                            {this.state.isEcom ?
                                <Translate value="pages.business.midDetails.ecomTitle"/>
                                :
                                <Translate value={"pages.business.midDetails" + (!this.props.isSingleAfmMid ? ".title" : ".singleTitle")}/>
                            }
                            <i className="icon-plus-accordion"></i>
                            <i className="icon-minus-accordion"></i>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="business-row business-row__details">
                                <div className="business-details__column">
                                    <Translate value="pages.business.midDetails.midTitle"/>
                                    <div className="business-details__value">{data.mid}</div>
                                </div>
                                <div className="editable-field__btn business-details__column">
                                    <span>
                                        <Translate value="pages.business.midDetails.midAlias"/>
                                        <span className="alias-tltps-wrapper">
                                            <Tooltip placement="right"
                                                     tooltipButtonId="businessMidAlias"
                                                     tooltipLabelClass="business-mid-alias-label"
                                                     popoverId="business-mid-alias-tltp"
                                                     tooltipText="tooltipMid"
                                            />
                                        </span>
                                    </span>
                                    <div className="editable-field__wrapper">
                                        <OverlayTrigger trigger="click"
                                                        placement="bottom"
                                                        overlay={popoverMerchantAlias}
                                                        show={this.state.showOverlayMerchantAlias}
                                                        container={!this.props.isSingleAfmMid ? this.overlayContainerRef: undefined}>
                                            <span onClick={() => this.toggleOverlayMerchantAlias()}>
                                                { data.merchantAlias ?
                                                    <span className="editable-field__value">{data.merchantAlias}</span> :
                                                    <Translate className="editable-field__no-value" value="pages.business.midDetails.provideAlias" />
                                                }
                                                <span className={"editable-field__icon icon-edit-pencil " + (data.merchantAlias ? 'icon-orange' : 'icon-gray')}></span>
                                            </span>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="business-details__column">
                                    <Translate value="pages.business.midDetails.midActivity"/>
                                    <div className="business-details__value">{data.mccDescription}</div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1"
                                    id="accordion-contact-details">
                        <Accordion.Header as='h4'>
                            <Translate value="pages.business.midDetails.contactDetails"/>
                            <i className="icon-plus-accordion"></i>
                            <i className="icon-minus-accordion"></i>
                        </Accordion.Header>
                        <Accordion.Body>
                            {!this.state.isEcom ?
                                <div className="business-row business-row__details">
                                    <div className={"business-details__column business-details__column--address " +
                                        (this.props.isSingleAfmMid ? "single-stats" : '')}>
                                        <Translate value="pages.business.midDetails.address"/>
                                        <div className="business-details__value">
                                            <span>{data.locationAddress1}
                                                {data.locationAddress2 ? ' & ' : null}
                                            </span>
                                            <span>{data.locationAddress2}</span>
                                        </div>
                                    </div>
                                    <OverlayTrigger trigger="click"
                                                    placement="bottom"
                                                    overlay={popoverPostCode}
                                                    ref="overlayPostCodeRef"
                                                    show={this.state.showOverlayPostCode}
                                                    container={!this.props.isSingleAfmMid ? this.overlayContainerRef : undefined}>
                                        <div onClick={() => this.toggleOverlayPostCode()}
                                             className="change-postal-code__btn business-details__column">
                                            <Translate value="pages.business.midDetails.postCode"/>
                                            <div className="change-postal-code__wrapper">
                                                {postCode ?
                                                    <span className="change-postal-code__value">{postCode}</span> :
                                                    <Translate className="change-postal-code__no-value" value="pages.business.midDetails.providePostalCode" />
                                                }
                                                <span className={"editable-field__icon icon-edit-pencil " + (postCode ? 'icon-orange' : 'icon-gray')}></span>
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                    <div className="business-details__column business-details__column--city">
                                        <Translate value="pages.business.midDetails.city"/>
                                        <div className="business-details__value">{data.locationCity ? data.locationCity : '-'}</div>
                                    </div>
                                    <div className="business-details__column business-details__column--area">
                                        <Translate value="pages.business.midDetails.area"/>
                                        <div className="business-details__value">{data.locationCountryArea ? data.locationCountryArea : '-'}</div>
                                    </div>
                                    <div className="business-details__column business-details__column--empty-helper">
                                    </div>
                                </div> : null}
                            <div className="business-row business-row__details">
                                <div className="business-details__column business-details__column--sub">
                                    <Translate value="pages.business.midDetails.phone1"/>
                                    <div className="business-details__value">{data.phone1 ? data.phone1 : '-'}</div>
                                </div>
                                <div className="business-details__column business-details__column--sub">
                                    <Translate value="pages.business.midDetails.phone2"/>
                                    <div className="business-details__value">{data.phone2 ? data.phone2 : '-'}</div>
                                </div>
                                <div className="business-details__column business-details__column--sub">
                                    <Translate value="pages.business.midDetails.phone3"/>
                                    <div className="business-details__value">{data.phone3 ? data.phone3 : '-'}</div>
                                </div>
                                <div className="business-details__column business-details__column--sub">
                                    <Translate value="pages.business.midDetails.mobilePhone"/>
                                    <div className="business-details__value">{data.mobilePhone ? data.mobilePhone : '-'}</div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                    <TerminalDetails
                        key={"terminal-details-" + data.mid}
                        mid = {data.mid}
                        modalRef = {this.businessModalRef.current}
                        data = {data.tidData}
                        locale = {this.props.locale}
                        setTidForSupport = {this.props.setTidForSupport}
                        selectedTid={this.props.selectedTid}
                        singleAfmMid = {this.props.isSingleAfmMid}
                        tidAliasTltpShown={this.props.userReducer.showInfo__business_tid_alias_tltp}
                        updateTerminalAllias = {this.props.updateTerminalAllias}
                    />
                    {this.props.data.midCardlinkOne || data.isEurobankErb ?
                      <PaymentsAndFees
                        mid={data.mid}
                        iban={data.isEurobankErb ? data.iban ? data.iban : '-' : this.props.iban ? this.props.iban : "-"}
                        isEurobankErb={data.isEurobankErb}
                        isCardlinkOne={this.props.data.midCardlinkOne}
                      />
                      : null}
                    {this.props.data.midCardlinkOne ?
                      <DebitNotes mid={data.mid}
                                  email={this.props.userReducer.profile.email ? this.props.userReducer.profile.email : null}
                                  afm={this.props.merchantReducer.afm ? this.props.merchantReducer.afm : null}
                                  tids={this.tidsSearchBoxData(data.tidData)}
                      />
                      : null}
                </Accordion>
            </div>
            </div>
        )
    }
}

export default connect(stateMap)(MidDetails);
